/*
 * Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

/**
 * SITEEDA-3378 moved header/footer/home/session-timeout into LayoutModule.
 * Keep this NgModule as the core bootstrap import; do not re-declare shell chrome here.
 */
@NgModule({
    imports: [
        CommonModule,
    ],
})
export class CoreModule {
}
